import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ClassificarState } from './types'
import { RootState } from '..'

const initialState: ClassificarState = {
  classificacaoSelecionada: {
    classificacaoMeuEspaco: 0,
    classificacaoAreasDeTrabalho: 0
  }
}

export const classificarSlice = createSlice({
  name: 'classificar',
  initialState,
  reducers: {
    setClassificacaoMeuEspaco: (state, action: PayloadAction<number>) => {
      state.classificacaoSelecionada.classificacaoMeuEspaco = action.payload
    },
    setClassificacaoAreasDeTrabalho: (state, action: PayloadAction<number>) => {
      state.classificacaoSelecionada.classificacaoAreasDeTrabalho =
        action.payload
    }
  }
})

export const { setClassificacaoMeuEspaco, setClassificacaoAreasDeTrabalho } =
  classificarSlice.actions
export const classificarReducer = classificarSlice.reducer
export const selectClassificacaoMeuEspaco = (state: RootState) =>
  state.classificar.classificacaoSelecionada.classificacaoMeuEspaco
export const selectClassificacaoAreasDeTrabalho = (state: RootState) =>
  state.classificar.classificacaoSelecionada.classificacaoAreasDeTrabalho
